import { Box, useDisclosure } from "@chakra-ui/react";

import { HStack, VStack } from "goi_common";

import UrgentModal from "@/components/common/Modal/UrgentModal";
import FacilityRelocateQuotation from "./components/MatchFacility/FacilityRelocateQuotation";

export default function MatchFacilityRequestContainer({ defaultFacility }: any) {
  const { isOpen, onClose } = useDisclosure();

  return (
    <VStack width="100%" alignItems="center">
      <UrgentModal onClose={onClose} isOpen={isOpen} />
      <VStack maxWidth="480px" width="100%">
        <VStack gap="10px" padding="18px 24px 24px">
          <h1 className="head2_b">{defaultFacility.companyname}</h1>
          <HStack alignItems="start" justifyContent="space-between">
            <Box className="head2_b black">개장, 이장 절차와 비용 알아보기</Box>
          </HStack>
        </VStack>
        <FacilityRelocateQuotation defaultFacility={defaultFacility} />
      </VStack>
    </VStack>
  );
}
